import '../../components/Alignment.css';
import '../../components/DataTableV2Rows.css';
import '../../DataTableV2.css';
import '../ColumnOrder/ColumnOrder.css';
import '../Thresholds/Thresholds.css';
import '../../components/DataTableV2Header.css';
import './Sorting.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var sortingArrowCSS = _7a468({defaultClassName:'_1h8kyn60-2-0-1',variantClassNames:{arrowUp:{true:'_1h8kyn61-2-0-1',false:'_1h8kyn62-2-0-1'},rowDensity:{'default':'_1h8kyn63-2-0-1',condensed:'_1h8kyn64-2-0-1',comfortable:'_1h8kyn65-2-0-1'}},defaultVariants:{},compoundVariants:[]});